const pagesContainerSelector = '.links-pages';
const pageSelector = '.links-page';
const paginationSelector = '.links-page-pagination';
const paginationEltSelector = '.links-page-selector';

const enabledPaginationEltClasses = ['cursor-pointer'];
const disabledPaginationEltClasses = ['text-brand-01', 'cursor-default'];

const getLinksPages = () => {
    return Array.from(document.querySelectorAll(pagesContainerSelector));
};

const getLinksPagesSections = () => {
    const sections = [];

    getLinksPages().forEach((linksPage) => {
        sections.push(linksPage.closest('section'));
    })

    return sections;
};

const hideAllPages = (pages) => {
    pages.forEach(page => {
        page.classList.add('hidden');
    });
};

const enableAllPaginationElts = (paginationElts) => {
    paginationElts.forEach(paginationElt => {
        if (paginationElt.hasAttribute('current')) {
            paginationElt.removeAttribute('current');
        }

        enabledPaginationEltClasses.forEach(className => {
            paginationElt.classList.add(className);
        });

        disabledPaginationEltClasses.forEach(className => {
            paginationElt.classList.remove(className);
        })
    });
};

const disablePaginationElt = (paginationElt) => {
    paginationElt.setAttribute('current', '');

    enabledPaginationEltClasses.forEach(className => {
        paginationElt.classList.remove(className);
    });

    disabledPaginationEltClasses.forEach(className => {
        paginationElt.classList.add(className);
    })
}

const displayPage = (page) => {
    page.classList.remove('hidden');
};

const goToPage = (page, pages) => {
    for (let i = 0; i < pages.length; i++) {
        const pageElt = pages[i];

        if (pageElt.hasAttribute('page-index') && parseInt(pageElt.getAttribute('page-index')) === page) {
            hideAllPages(pages);
            displayPage(pageElt);

            return true;
        }
    }

    return false;
};

const handleClickOnPage = (pageElt, paginationElts, pages, section) => {
    if (!pageElt.hasAttribute('current') && pageElt.hasAttribute('page-index')) {
        const pageIndex = parseInt(pageElt.getAttribute('page-index'));

        if (goToPage(pageIndex, pages)) {
            enableAllPaginationElts(paginationElts);
            disablePaginationElt(pageElt);

            const aboveOffset = 128;

            let bodyRect = document.body.getBoundingClientRect(),
                sectionRect = section.getBoundingClientRect(),
                offset = sectionRect.top - bodyRect.top - aboveOffset;

            window.scrollTo({
                top: offset,
                behavior: 'smooth'
            });
        }
    }
};

const initSection = (section) => {
    const pagesContainer = section.querySelector(pagesContainerSelector);
    const pages = Array.from(pagesContainer.querySelectorAll(pageSelector));
    const pagination = section.querySelector(paginationSelector);

    if (pagination) {
        const paginationElts = Array.from(pagination.querySelectorAll(paginationEltSelector));

        paginationElts.forEach(paginationElt => {
            paginationElt.addEventListener('click', (e) => {
                handleClickOnPage(e.target, paginationElts, pages, section);
            });
        });
    }
};

document.addEventListener('DOMContentLoaded', () => {
    getLinksPagesSections().forEach(section => {
        initSection(section);
    });
});
